// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__X80ou","main_box":"App_main_box__2R8ec"};